var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isEmpty, isValid, stringLength, isStr, isArr, isFn, toArr, isBool, isNum, isEqual, each, } from '@formily/shared';
import { getValidateFormats } from './registry';
var isValidateEmpty = function (value) {
    var _a;
    if (isArr(value)) {
        for (var i = 0; i < value.length; i++) {
            if (isValid(value[i]))
                return false;
        }
        return true;
    }
    else {
        //compat to draft-js
        if (value === null || value === void 0 ? void 0 : value.getCurrentContent) {
            /* istanbul ignore next */
            return !((_a = value.getCurrentContent()) === null || _a === void 0 ? void 0 : _a.hasText());
        }
        return isEmpty(value);
    }
};
var getLength = function (value) {
    return isStr(value) ? stringLength(value) : value ? value.length : 0;
};
var extendSameRules = function (rules, names) {
    each(names, function (realName, name) {
        rules[name] = function (value, rule) {
            var _a;
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            return rules[realName].apply(rules, __spreadArray([value, __assign(__assign({}, rule), (_a = {}, _a[realName] = rule[name], _a))], __read(args), false));
        };
    });
};
var RULES = {
    format: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        if (rule.format) {
            var format = getValidateFormats(rule.format);
            if (format) {
                return !new RegExp(format).test(value) ? rule.message : '';
            }
        }
        return '';
    },
    required: function (value, rule) {
        if (rule.required === false)
            return '';
        return isValidateEmpty(value) ? rule.message : '';
    },
    max: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        var length = isNum(value) ? value : getLength(value);
        var max = Number(rule.max);
        return length > max ? rule.message : '';
    },
    min: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        var length = isNum(value) ? value : getLength(value);
        var min = Number(rule.min);
        return length < min ? rule.message : '';
    },
    exclusiveMaximum: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        var length = isNum(value) ? value : getLength(value);
        var max = Number(rule.exclusiveMaximum);
        return length >= max ? rule.message : '';
    },
    exclusiveMinimum: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        var length = isNum(value) ? value : getLength(value);
        var min = Number(rule.exclusiveMinimum);
        return length <= min ? rule.message : '';
    },
    len: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        var length = getLength(value);
        var len = Number(rule.len);
        return length !== len ? rule.message : '';
    },
    pattern: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        return !new RegExp(rule.pattern).test(value) ? rule.message : '';
    },
    validator: function (value, rule, context, format) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isFn(rule.validator)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.resolve(rule.validator(value, rule, context, format))];
                    case 1:
                        response = _a.sent();
                        if (isBool(response)) {
                            return [2 /*return*/, !response ? rule.message : ''];
                        }
                        else {
                            return [2 /*return*/, response];
                        }
                        _a.label = 2;
                    case 2: 
                    /* istanbul ignore next */
                    throw new Error("The rule's validator property must be a function.");
                }
            });
        });
    },
    whitespace: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        if (rule.whitespace) {
            return /^\s+$/.test(value) ? rule.message : '';
        }
    },
    enum: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        var enums = toArr(rule.enum);
        return enums.indexOf(value) === -1 ? rule.message : '';
    },
    const: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        return rule.const !== value ? rule.message : '';
    },
    multipleOf: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        return Number(value) % Number(rule.multipleOf) !== 0 ? rule.message : '';
    },
    uniqueItems: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        value = toArr(value);
        return value.some(function (item, index) {
            for (var i = 0; i < value.length; i++) {
                if (i !== index && !isEqual(value[i], item)) {
                    return false;
                }
            }
            return true;
        })
            ? ''
            : rule.message;
    },
    maxProperties: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        return Object.keys(value || {}).length <= Number(rule.maxProperties)
            ? ''
            : rule.message;
    },
    minProperties: function (value, rule) {
        if (isValidateEmpty(value))
            return '';
        return Object.keys(value || {}).length >= Number(rule.minProperties)
            ? ''
            : rule.message;
    },
};
extendSameRules(RULES, {
    maximum: 'max',
    minimum: 'min',
    maxItems: 'max',
    minItems: 'min',
    maxLength: 'max',
    minLength: 'min',
});
export default RULES;
//# sourceMappingURL=rules.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/validator/esm/rules.js
// module id = null
// module chunks = 